import { createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "layer ly_pop cellphone_cert",
  style: {"display":"block"}
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "layer_tit" }, [
  /*#__PURE__*/_createVNode("h2", { class: "tit_txt" }, "휴대폰 인증"),
  /*#__PURE__*/_createVNode("p", { class: "desc_txt" }, [
    /*#__PURE__*/_createTextVNode("비회원은 교환권 구매 및 선물함 이용을 위해 "),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("휴대폰 인증이 필요합니다.")
  ])
], -1)
const _hoisted_3 = { class: "ly_cont" }
const _hoisted_4 = { class: "inp_bx" }
const _hoisted_5 = { class: "inp_txt" }
const _hoisted_6 = {
  class: "inp_placeholder",
  style: {"display":"block"}
}
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "ico_del" }, "입력 내용 지우기", -1)
const _hoisted_8 = { class: "inp_wrap" }
const _hoisted_9 = { class: "inp_group" }
const _hoisted_10 = { class: "inp_bx" }
const _hoisted_11 = { class: "inp_txt" }
const _hoisted_12 = {
  class: "inp_placeholder",
  style: {"display":"block"}
}
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "ico_del" }, "입력 내용 지우기", -1)
const _hoisted_14 = { class: "inp_bx time_add" }
const _hoisted_15 = { class: "inp_txt" }
const _hoisted_16 = {
  class: "inp_placeholder",
  style: {"display":"block"}
}
const _hoisted_17 = {
  class: "time_bx",
  style: {"display":"block"}
}
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "blind" }, "유효시간", -1)
const _hoisted_19 = { class: "txt_point" }
const _hoisted_20 = { class: "checkbox_area" }
const _hoisted_21 = { class: "box_terms" }
const _hoisted_22 = { class: "checkbox" }
const _hoisted_23 = /*#__PURE__*/_createVNode("label", {
  for: "chk_agree",
  class: "checkbox_lbl"
}, "개인정보 제3자 제공 동의(필수)", -1)
const _hoisted_24 = /*#__PURE__*/_createStaticVNode("<div class=\"terms_scroll\"><h3 class=\"terms_tit\">1. 수집하는 개인정보 항목</h3><p class=\"terms_txt\">- 보내는 분 성명, 휴대폰 번호</p><h3 class=\"terms_tit\">2. 수집하는 개인정보 이용목적</h3><ol class=\"terms_txt\"><li>- 비회원의 선물하기 이용 시 휴대폰 점유인증 진행</li><li>- 선물함 내역 조회 기능 제공 및 고객민원처리</li></ol><h3 class=\"terms_tit emphasis\">3. 개인정보의 보유 및 이용기간</h3><p class=\"terms_txt emphasis\">- 주문일로부터 5년간 보존 후 파기</p><h3 class=\"terms_tit\">4. 고객님은 동의를 거부하실 수 있으나, 서비스 제공에 필요한 최소한의 정보이므로 동의하지 않으실 경우 서비스 이용이 제한될 수 있습니다.</h3></div>", 1)
const _hoisted_25 = { class: "ly_btn_area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("span", _hoisted_4, [
        _createVNode("span", _hoisted_5, [
          _withDirectives(_createVNode("span", _hoisted_6, "이름", 512), [
            [_vShow, !_ctx.hasInputName]
          ]),
          _createVNode("input", {
            value: _ctx.inputName,
            onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setInputName && _ctx.setInputName(...args))),
            type: "text",
            class: "inp",
            title: "이름"
          }, null, 40, ["value"]),
          _withDirectives(_createVNode("button", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.eraseInputName && _ctx.eraseInputName(...args))),
            type: "button",
            class: "btn_del",
            style: {"display":"block"}
          }, [
            _hoisted_7
          ], 512), [
            [_vShow, _ctx.hasInputName]
          ])
        ])
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _createVNode("span", _hoisted_10, [
            _createVNode("span", _hoisted_11, [
              _withDirectives(_createVNode("span", _hoisted_12, "휴대폰 번호 (-없이 입력)", 512), [
                [_vShow, !_ctx.hasInputPhoneNumber]
              ]),
              _createVNode("input", {
                value: _ctx.inputPhoneNumber,
                onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.setInputPhoneNumber && _ctx.setInputPhoneNumber(...args))),
                type: "tel",
                class: "inp",
                title: "휴대폰 번호",
                maxlength: "11"
              }, null, 40, ["value"]),
              _withDirectives(_createVNode("button", {
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.eraseInputPhoneNumber && _ctx.eraseInputPhoneNumber(...args))),
                type: "button",
                class: "btn_del",
                style: {"display":"block"}
              }, [
                _hoisted_13
              ], 512), [
                [_vShow, _ctx.hasInputPhoneNumber]
              ])
            ])
          ]),
          _createVNode("a", {
            onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendAuthenticationNumber && _ctx.sendAuthenticationNumber(...args)), ["prevent"])),
            href: "#",
            class: "btn"
          }, "인증번호 발송")
        ])
      ]),
      _createVNode("span", _hoisted_14, [
        _createVNode("span", _hoisted_15, [
          _withDirectives(_createVNode("span", _hoisted_16, "인증번호 (6자리 숫자)", 512), [
            [_vShow, !_ctx.hasAuthenticationNumber]
          ]),
          _createVNode("input", {
            value: _ctx.authenticationNumber,
            onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.setAuthenticationNumber && _ctx.setAuthenticationNumber(...args))),
            type: "tel",
            class: "inp",
            title: "인증번호",
            maxlength: "6"
          }, null, 40, ["value"]),
          _withDirectives(_createVNode("span", _hoisted_17, [
            _hoisted_18,
            _createVNode("em", _hoisted_19, _toDisplayString(_ctx.remainingTimeString), 1)
          ], 512), [
            [_vShow, _ctx.authenticationRequested]
          ])
        ])
      ]),
      _createVNode("div", _hoisted_20, [
        _createVNode("div", _hoisted_21, [
          _createVNode("div", _hoisted_22, [
            _withDirectives(_createVNode("input", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.personalInformationConsent = $event)),
              type: "checkbox",
              id: "chk_agree",
              class: "checkbox_inp"
            }, null, 512), [
              [_vModelCheckbox, _ctx.personalInformationConsent]
            ]),
            _hoisted_23
          ])
        ])
      ]),
      _hoisted_24
    ]),
    _createVNode("div", _hoisted_25, [
      _createVNode("button", {
        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.authenticatePhoneNumber && _ctx.authenticatePhoneNumber(...args))),
        type: "button",
        class: ["btn btn_confirm", {'is_inactive': !_ctx.canMoveToNextStep}],
        disabled: !_ctx.canMoveToNextStep
      }, "확인", 10, ["disabled"])
    ]),
    _createVNode("a", {
      href: "#",
      onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.$emit('closeCellphoneAuthenticationPopup')), ["prevent"])),
      class: "btn_close"
    }, "팝업 닫기")
  ]))
}